"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Appointment = exports.fragments = void 0;
var React = __importStar(require("react"));
var graphql_tag_1 = __importDefault(require("graphql-tag"));
var styled_components_1 = __importDefault(require("styled-components"));
var Actions = __importStar(require("../calendar-actions"));
var graphql_client_1 = require("../../graphql/graphql-client");
var date_utils_1 = require("../../date-utils");
exports.fragments = {
    appointment: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment Appointment_Appointment on Appointment {\n      id\n      start\n      end\n      notes\n    }\n  "], ["\n    fragment Appointment_Appointment on Appointment {\n      id\n      start\n      end\n      notes\n    }\n  "]))),
};
var deleteAppointmentMutation = (0, graphql_tag_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  mutation DeleteAppointment($input: DeleteAppointmentInput!) {\n    deleteAppointment(input: $input) {\n      rejected\n    }\n  }\n"], ["\n  mutation DeleteAppointment($input: DeleteAppointmentInput!) {\n    deleteAppointment(input: $input) {\n      rejected\n    }\n  }\n"])));
var AppointmentDiv = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-weight: bold;\n"], ["\n  font-weight: bold;\n"])));
function Appointment(_a) {
    var _this = this;
    var dispatch = _a.dispatch, appointment = _a.appointment, personId = _a.personId, userName = _a.userName, requery = _a.requery;
    var graphqlClient = React.useContext(graphql_client_1.GraphqlClientContext);
    var formattedStartAndEnd = (0, date_utils_1.formattedStartAndEndTime)(appointment.start, appointment.end);
    return (React.createElement("div", null,
        React.createElement("input", { title: "Edit", type: "button", value: "E", onClick: function (e) {
                e.stopPropagation();
                e.preventDefault();
                dispatch(Actions.openAppointmentDialog(appointment.id, personId, userName, (0, date_utils_1.unixTimeToDate)(appointment.start), (0, date_utils_1.unixTimeToDate)(appointment.end), appointment.notes || ""));
            } }),
        React.createElement("input", { title: "Delete", type: "button", value: "D", onClick: function (e) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            e.stopPropagation();
                            e.preventDefault();
                            return [4 /*yield*/, graphqlClient.runMutation(deleteAppointmentMutation, {
                                    input: { appointmentId: appointment.id },
                                })];
                        case 1:
                            _a.sent();
                            requery();
                            return [2 /*return*/];
                    }
                });
            }); } }),
        React.createElement(AppointmentDiv, null, appointment.notes),
        formattedStartAndEnd === "08:00 - 17:00" ? React.createElement("div", null) : React.createElement("div", null, formattedStartAndEnd)));
}
exports.Appointment = Appointment;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=appointment.js.map